<!--
 * @Author: QWX
 * @Description:主订单详情抽屉
 * @LastEditors: 张小虎
 * @LastEditTime: 2022-06-15 17:57:32
-->
<template>
  <el-drawer
    title="主订单详情"
    :visible.sync="drawer"
    v-if="drawer"
    size="900px"
    class="order-detail"
    append-to-body
    :destroy-on-close="refresh"
    direction="rtl">
    <zl-saas-container v-loading="loading">
      <div class="order-oper-btn-box">
        <operRecord :id="id" />
      </div>
      <div class="order-info" >
        <img src="~@/assets/images/reconciliationAndSettlement/order-logo.svg" alt="">
        <h3>{{baseInfo.orderName}}<span :class="['status-box', `status-${baseInfo.status}`]">{{getValue('mainOrderStatus', baseInfo.status)}}</span></h3>
        <div>
          订单编号：{{baseInfo.orderCode}}
          <el-divider direction="vertical"></el-divider>
          订单类型：{{getValue('inquireType', baseInfo.purchaseType)}}
          <el-divider direction="vertical"></el-divider>
          订单种类：{{getValue('orderCategory', baseInfo.purchaseType)}}
          <el-divider direction="vertical"></el-divider>
          电子订单：<el-link @click="showOrderDialog" type="primary">电子订单.pdf</el-link>
        </div>
      </div>
      <el-tabs v-model="activeName" >
        <el-tab-pane label="" name="1">
          <span slot="label" class="self-tabs">主订单信息</span>
          <div class="orderDetail-m-b orderDetail-tabs-body">
            <div>
              <div >
                <span class="saas-card-header-name">订单基本信息</span>
              </div>
              <div class="order-content-detail">
                <el-form
                  :model="baseInfo"
                  label-position="right"
                  label-width="150px"
                  :gutter="20"
                  disabled
                >
                  <el-row :gutter="20" v-if="baseInfo.projectId || isNotInJcSys">
                    <el-col :span="12">
                      <el-form-item label="履约项目编号：" prop="projectCode">
                        <el-input v-model="baseInfo.projectCode"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="履约项目名称：" prop="projectName" class="form-items__btn">
                        <el-input v-model="baseInfo.projectName"></el-input>
                        <span v-if="!isNotInJcSys" class="detail-btn" @click="skipDetailPage(1)">详情</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" v-if="baseInfo.inquireId">
                    <el-col :span="12">
                      <el-form-item label="询单编号：" prop="inquireCode">
                        <el-input v-model="baseInfo.inquireCode"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="询单名称：" prop="inquireName" class="form-items__btn">
                        <el-input v-model="baseInfo.inquireName"></el-input>
                        <span class="detail-btn" @click="skipDetailPage(2)">详情</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="付款方式占比：">
                        <template v-if="baseInfo.payTypeList && baseInfo.payTypeList.length > 1">
                          <el-descriptions direction="vertical" :column="baseInfo.payTypeList.length" border>
                            <el-descriptions-item label-class-name="my-label" :label="`${item.name}(%)`" v-for="item in baseInfo.payTypeList" :key="item.id">{{item.value}}%</el-descriptions-item>
                          </el-descriptions>
                        </template>
                        <template v-else>
                          <span>{{baseInfo.payTypeList && baseInfo.payTypeList[0].name}}</span>
                        </template>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="项目组成员：" prop="projectUser">
                        <member-select
                          :disabled="true"
                          :authType="40"
                          v-model="baseInfo.projectUser"
                        ></member-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="采购单位：" prop="purchaseName">
                        <el-input v-model="baseInfo.purchaseName"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="订单联系人：" prop="contactName">
                        <el-input v-model="baseInfo.contactName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="contactPhone" label="订单人联系电话：">
                        <el-input v-model="baseInfo.contactPhone">
                          <el-select
                            size="mini"
                            style="width:100px"
                            v-model="baseInfo.contactPhonePrefix"
                            slot="prepend"
                            placeholder="请选择"
                          >
                            <!-- <el-option label="中国+86" value="+86"></el-option> -->
                            <el-option
                              v-for="(item, index) in enums.phoneAreaCodeList"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            >{{ item.label }}</el-option
                            >
                          </el-select>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="币种：" prop="currencyCH">
                        <el-input v-model="baseInfo.currencyCH"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="供应商编号：" prop="supplierCorp">
                        <el-input v-model="secondDetailInfo.supplierCorp"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="供应商名称：" prop="supplierName">
                        <el-input v-model="secondDetailInfo.supplierName"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="供应商联系人：" prop="supplierContactName">
                        <el-input v-model="secondDetailInfo.supplierContactName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="供应商联系人电话：" prop="supplierContactPhone">
                        <el-input v-model="secondDetailInfo.supplierContactPhone"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="附件：" prop="fileId">
                        <zsFileDownload :fileId="baseInfo.fileId"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-form-item label="备注" prop="remark">
                        <el-input v-model="baseInfo.remark" type="textarea" rows="3"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
              <div>
              </div>
            </div>
            <div>
              <div slot="header" class="clearfix">
                <span class="saas-card-header-name">收货信息</span>
              </div>
              <div class="order-content-detail">
                <el-form
                  :model="secondDetailInfo"
                  label-position="right"
                  label-width="150px"
                  :gutter="20"
                  disabled
                >
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="收货人：" prop="consignee">
                        <el-input v-model="secondDetailInfo.consignee"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="联系电话：" prop="consigneePhone">
                        <el-input v-model="secondDetailInfo.consigneePhone"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="交货地址：" prop="address">
                        <el-input v-model="secondDetailInfo.address"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="交货时间：" prop="receiveTime">
                        <el-date-picker
                          class="w100"
                          v-model="secondDetailInfo.receiveTime"
                          type="datetime"
                          placeholder="交货时间"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>

            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="" name="2">
          <span slot="label" class="self-tabs">清单</span>
          <div class="orderDetail-m-b orderDetail-tabs-body">
            <div slot="header" class="clearfix">
              <span class="saas-card-header-name">{{ getValue('orderCategory',baseInfo.purchaseType)}}清单</span>
            </div>
            <div  style="text-align:right;margin-bottom: 20px">
              <el-button type="primary" @click="exportOrderList">导出清单</el-button>
            </div>
            <zl-server-page-table
              :border="false"
              showTotal
              ref="multipleTable"
              :api="getGoodsApi"
            >
              <el-table-column
                v-for="(row, index) in listColumns"
                :key="index"
                :label="row.columnNameCH"
                :prop="row.columnNameEN"
              >
              </el-table-column>
            </zl-server-page-table>
            <div class="order-detail-total-box">
              <!-- <p v-if="baseInfo.orderType === 1 "> -->
              <p class="item-budget">
                <span>订单预算(元)：</span>
                <span>{{secondDetailInfo.budgetAmount | $zlFiltersMoneyFormat}}</span>
              </p>
              <i class="item-dot"></i>
              <p class="item-sum">
                <span>含税总价(元)：</span>
                <span class="money">{{secondDetailInfo.budgetAmount | $zlFiltersMoneyFormat}}</span>
              </p>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="" name="3">
          <span slot="label" class="self-tabs">子订单信息</span>
          <div class="orderDetail-m-b orderDetail-tabs-body">
            <div class=" m-b">
              <span class="saas-card-header-name">子订单信息</span>
            </div>
            <zl-server-page-table
              :border="false"
              showTotal
              ref="multipleTable"
              :api="getSuborderApi"
              :columns="subordercolumns"
            >
            </zl-server-page-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="" name="4">
          <span slot="label" class="self-tabs">付款信息</span>
          <div class="orderDetail-m-b orderDetail-tabs-body">
            <div class="m-b">
              <span class="saas-card-header-name">付款信息</span>
            </div>
            <zl-server-page-table
              :border="false"
              showTotal
              ref="multipleTable"
              :api="getPayApi"
              :columns="payColumns"
            >
            </zl-server-page-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="" name="5" v-if="invoiceInfo">
          <span slot="label" class="self-tabs">开票记录</span>
          <div class="orderDetail-tabs-body">
            <div slot="header" class="clearfix">
              <span class="saas-card-header-name">开票记录</span>
            </div>
            <div class="order-content-detail">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="common-item">
                    <span>开票单：</span>
                    <span><router-link to="">{{invoiceInfo.invoiceCode}}</router-link></span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="common-item">
                    <span>状态：</span>
                    <span>{{getValue('invoiceStatus', invoiceInfo.status)}}</span>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="common-item">
                    <span>申请开票金额(元)：</span>
                    <span>{{invoiceInfo.invoiceMoney | $zlFiltersMoneyFormat}}</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </zl-saas-container>
  </el-drawer>
</template>

<script>
import operRecord from '@/components/business/operRecord.vue'
import store from '@/store'
import dayjs from 'dayjs'
import memberSelect from '@/components/business/memberSelect'
import { getValue, enums } from '@/lib/enum'
import electronicCertDialog from '@/components/dialog/electronicCertDialog'
import zsFileDownload from '@/components/zsFileDownload'
export default {
  components: {
    memberSelect,
    zsFileDownload,
    operRecord
  },
  props: {
    // 是否需要在重新打开抽屉的时候刷新数据
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enums,
      dayjs,
      getValue,
      id: '',
      drawer: false,
      loading: false,
      baseInfo: {},
      basicInfo: {},
      invoiceInfo: null,
      secondDetailInfo: {},
      secondInfo: {},
      activeName: '1',
      listColumns: [],
      //   子订单表头
      subordercolumns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '子订单编号',
          prop: 'subOrderCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '发布时间',
          prop: 'createTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.createTime &&
            dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          label: '状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('subOrderStatus', row.status)
        }
      ],
      //   付款表头
      payColumns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '付款单号',
          prop: 'orderPayCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '申请付款金额(元)',
          prop: 'applyMoney',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.applyMoney && this.$zl.util.splitK(row.applyMoney)
        },
        {
          label: '实际付款金额(元)',
          prop: 'realMoney',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.realMoney && this.$zl.util.splitK(row.realMoney)
        },
        {
          label: '提交时间',
          prop: 'createTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) =>
            row.createTime &&
            dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss')
        },
        {
          label: '付款状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          render: (h, row) => (
            <span>
              <span>{row.status === 1 ? '待付款' : '已付款'}</span>
            </span>
          )
        }
      ],
      // 付款方式占比表头
      payTypeList: [
        {
          id: 1,
          name: '预付款',
          value: ''
        },
        {
          id: 2,
          name: '发货款',
          value: ''
        },
        {
          id: 3,
          name: '到货款',
          value: ''
        },
        {
          id: 4,
          name: '安装/调试款',
          value: ''
        },
        {
          id: 5,
          name: '质保金/质保函',
          value: ''
        },
        {
          id: 6,
          name: '其他',
          value: ''
        }
      ]
    }
  },
  computed: {
    // 是否集采-不使用集采系统内履约的项目
    isNotInJcSys() {
      return +this.baseInfo.purchaseType === 2 && this.baseInfo.isUseXiTongNeiProject === 0
    }
  },
  methods: {
    open(id) {
      this.drawer = true
      this.id = id
      this.activeName = '1'
      this.init()
    },
    init() {
      this.loading = true
      store.dispatch('getFirstOrderStepZS', {
        id: this.id
      }).then(res => {
        this.loading = false
        if (res.percent) {
          let percent = res.percent.split('|')
          this.payTypeList.map((item, index) => {
            item.value = percent[index] !== '0' ? percent[index] : ''
            // 如果是其他付款方式，则显示自定义付款方式名称
            if (res.othenName && item.id === 6) {
              item.name = res.othenName
            }
          })
        }
        this.baseInfo = {
          ...res
        }
        this.baseInfo.orderType = this.baseInfo.orderType.toString()
        this.baseInfo.purchaseType = this.baseInfo.purchaseType.toString()
        if (this.payTypeList.some(val => val.value)) {
          this.basicInfo.payTypeList = [...this.payTypeList.filter(val => val.value)]
        }
      }).catch(() => {
        this.loading = false
      })
      store.dispatch('getSecondOrderStepZS', {
        id: this.id
      }).then(res => {
        this.secondDetailInfo = res
      })
      this.getDdColumn()
      this.getInvoiceOrderInfo()
      this.handleIsFlower()
    },
    // 导出订单清单
    exportOrderList() {
      store.dispatch(`${store.state.system === 'purchaser' ? 'exportDDInventoryMainOrder' : 'exportDDInventoryMainOrderGys'}`, {
        id: this.id
      }).then(res => {
        this.$zl.util.blobDownload(res, '订单清单.xls')
      })
    },
    // 显示电子凭证
    showOrderDialog() {
      this.$zl.dialog.openFull(electronicCertDialog, {
        orderId: this.baseInfo.id,
        system: this.$store.state.system
      }).then(() => {

      })
    },
    // 获取订单清单表头
    getDdColumn() {
      store.dispatch('getDdColumnZSGys', {
        unionId: this.id
      }).then(res => {
        // 初始表头
        const listColumns = JSON.parse(res.colValue || '[]')
        if (listColumns.length) {
          // 在最新的表头后面添加‘到货数量’，‘验收数量’，‘退货数量’，‘换货数量’
          const length = listColumns.length
          const deliverSize = {
            columnNameCH: '累计发货数量',
            columnNameEN: 'deliverSize',
            seq: length
          }
          const arrivalSize = {
            columnNameCH: '累计到货数量',
            columnNameEN: 'arrivalSize',
            seq: length + 1
          }
          const checkSize = {
            columnNameCH: '累计验收数量',
            columnNameEN: 'checkSize',
            seq: length + 2
          }
          const returnSize = {
            columnNameCH: '累计退货数量',
            columnNameEN: 'returnSize',
            seq: length + 3
          }
          const barterSize = {
            columnNameCH: '累计换货数量',
            columnNameEN: 'barterSize',
            seq: length + 4
          }
          listColumns.push(deliverSize, arrivalSize, checkSize, returnSize, barterSize)

          this.listColumns = listColumns
        }
      })
    },
    // 获取开票记录
    getInvoiceOrderInfo() {
      store.dispatch('listInvoiceMainOrderByOrderIdGys', {
        orderId: this.id
      }).then(res => {
        if (res && res.length) {
          this.invoiceInfo = {
            invoiceCode: res[0].invoiceCode,
            status: res[0].status,
            invoiceMoney: res[0].invoiceMoney
          }
        }
      })
    },
    /**
     * @description: 货物清单列表
     * @param {*} args
     * @return {*}
     */
    getGoodsApi(args) {
      return store.dispatch('pageDdInventoryMainOrder', {
        unionId: this.id,
        pageNum: args.page,
        pageSize: args.size
      }).then(res => {
        return {
          rows: res.list.map(
            (t) => {
              t.rowValue = t.rowValue && JSON.parse(t.rowValue) || {}
              t.rowValue.deliverSize = t.deliverSize || 0
              t.rowValue.arrivalSize = t.arrivalSize || 0
              t.rowValue.checkSize = t.checkSize || 0
              t.rowValue.returnSize = t.returnSize || 0
              t.rowValue.barterSize = t.barterSize || 0
              return t.rowValue
            }
          ),
          total: res.totalCount
        }
      })
    },
    /**
     * @description: 子订单列表
     * @param {*} args
     * @return {*}
     */
    getSuborderApi(args) {
      return store.dispatch(this.$store.state.system === 'purchaser' ? 'pageCgrSubOrder' : 'pageGysSubOrder', {
        orderId: this.id,
        pageNum: args.page,
        pageSize: args.size
      }).then(res => {
        // 用于父组件子订单信息是否显示，么有就不显示
        if (res.list && res.list.length) {
          this.$emit('update:hasChildata', true)
        } else {
          this.$emit('update:hasChildata', false)
        }
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    /**
     * @description: 付款列表
     * @param {*} args
     * @return {*}
     */
    getPayApi(args) {
      return store.dispatch('getPayListByOrderId', {
        orderId: this.id,
        pageNum: args.page,
        pageSize: args.size
      }).then(res => {
        // 用于父组件子订单信息是否显示，么有就不显示
        if (res.list && res.list.length) {
          this.$emit('update:hasPayData', true)
        } else {
          this.$emit('update:hasPayData', false)
        }
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    // 跳至相应的详情接口
    skipDetailPage(type) {
      this.$router.push({
        name: type === 1 ? 'PurchaserContractCheck' : 'InquiryBillCheck',
        query: {
          id: type === 1 ? this.baseInfo.projectId : this.baseInfo.inquireId,
          isOrder: type === 1, // 跳至合同详情页需要
          isFlower: type === 1 ? this.isFlower : '' // 是否是审批人
        }
      })
      this.drawer = false
    },
    // 判断当前登录用户是否订单审批人，如果是则该用户可以看到跳转到合同详情页的全部内容
    handleIsFlower() {
      store.dispatch('judgeIsFlowUser', {
        unionId: this.id
      }).then(res => {
        this.isFlower = res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/order.scss';
@import '@/assets/css/reconciliationAndSettlement.scss';
::v-deep.zl-saas-contianer .saas-contianer-main__contant{
  padding: 0 !important;
  .my-label{
      background: #E4E8F2FF;
  }
}
.order-detail .el-card{
  border: none;
  box-shadow: none;
}
.order-detail-total-box{
    height: 48px;
    padding-right: 24px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .item-budget{
        font-size: 14px;
        font-weight: 400;
        color: rgba(31, 46, 84, 0.45);
        line-height: 20px;
        height: 20px;
    }
    .item-sum{
        font-size: 14px;
        font-weight: 600;
        color: #1F2E54;
        line-height: 20px;
        height: 20px;
        .money{
            line-height: 0;
            font-size: 20px;
            color: #FF8B26FF;
        }
    }
    .item-dot{
        display: inline-block;
        width: 5px;
        height: 20px;
        margin: 0 10px;
        font-size: 0;
        line-height: 20px;
        &::before{
            content: "";
            vertical-align: middle;
            display: inline-block;
            width: 5px;
            height: 5px;
            background: rgba(31, 46, 84, 0.45);
            border-radius: 50%;
        }
    }
}
.order-oper-btn-box{
  position: absolute;
  right: 6px;
  top: 4px;
}
</style>
